import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import AdminSidebar from '../../components/AdminSidebar';
import '../../components/AdminTables.css';
import { getToken } from '../../utils/auth';

function CandidatesAdmin() {
  const [elections, setElections] = useState([]);
  const [selectedElection, setSelectedElection] = useState('');
  const [selectedOffice, setSelectedOffice] = useState('GOV');
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const officeOptions = [
    { value: 'STS', label: 'State Senator' },
    { value: 'STR', label: 'State Representative' },
    { value: 'GOV', label: 'Governor' },
    { value: 'LTG', label: 'Lieutenant Governor' },
    { value: 'AGR', label: 'Commissioner of Agriculture' },
    { value: 'CFO', label: 'Chief Financial Officer' },
    { value: 'EDU', label: 'Commissioner of Education' },
    { value: 'SEC', label: 'Secretary of State' },
    { value: 'ATG', label: 'Attorney General' }
  ];

  useEffect(() => {
    const fetchElections = async () => {
      try {
        const res = await fetch('/api/electioncodes');
        if (res.ok) {
          const data = await res.json();
          const filtered = data.filter(c => c.name && c.name.endsWith('Election')).map(c => ({ value: c.value, label: c.name }));
          setElections(filtered);
          if (filtered[0]) {
            const found2026 = filtered.find(fe => String(fe.value).includes('2026'));
            setSelectedElection(found2026 ? found2026.value : filtered[0].value);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchElections();
  }, []);

  useEffect(() => {
    const fetchCandidates = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = getToken();
        const params = new URLSearchParams();
        if (selectedElection) params.append('election', selectedElection);
        if (selectedOffice) params.append('office', selectedOffice);
        const res = await fetch('/api/admin/candidates?' + params.toString(), { headers: { 'x-auth-token': token } });
        if (!res.ok) {
          throw new Error('Failed to fetch');
        }
        const data = await res.json();
        setCandidates(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (selectedElection && selectedOffice) fetchCandidates();
  }, [selectedElection, selectedOffice]);

  // Basic delete
  const handleDelete = async (acctNum) => {
    if (!window.confirm('Delete candidate ' + acctNum + '?')) return;
    try {
      const token = getToken();
      const res = await fetch('/api/admin/candidates/' + acctNum, { method: 'DELETE', headers: { 'x-auth-token': token } });
      if (!res.ok) throw new Error('Delete failed');
      setCandidates(candidates.filter(c => c.AcctNum !== acctNum));
    } catch (err) {
      alert('Error deleting: ' + err.message);
    }
  };

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
  <div style={{ display: 'flex', maxWidth: '1200px', margin: '8px auto', boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: 12, background: '#fff' }}>
          <h2 style={{ marginTop: 0 }}>Manage Candidates</h2>

          <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
            <div>
              <label style={{ display: 'block' }}>Election</label>
              <select value={selectedElection} onChange={e => setSelectedElection(e.target.value)}>
                {elections.map(e => <option key={e.value} value={e.value}>{e.label}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display: 'block' }}>Office</label>
              <select value={selectedOffice} onChange={e => setSelectedOffice(e.target.value)}>
                {officeOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
          </div>

          {loading && <div>Loading...</div>}
          {error && <div style={{ color: 'red' }}>{error}</div>}

          <table className="admin-table">
            <thead>
              <tr>
                <th>AcctNum</th>
                <th>Voter ID</th>
                <th>Name</th>
                <th>Party</th>
                <th>Office</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {candidates.map(c => (
                <tr key={c._id}>
                  <td>{c.AcctNum}</td>
                  <td>{c.VoterID ?? c.VoterId ?? c.Voter ?? ''}</td>
                  <td>{(c.NameFirst || '') + ' ' + (c.NameLast || '')}</td>
                  <td>{c.PartyCode}</td>
                  <td>{c.OfficeCode}</td>
                  <td>
                    <div className="admin-actions">
                      <button className="btn btn-edit" onClick={() => window.location = '/admin/candidates/edit/' + c.AcctNum}>Edit</button>
                      <button className="btn btn-delete" onClick={() => handleDelete(c.AcctNum)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </main>
      </div>
    </div>
  );
}

export default CandidatesAdmin;
